/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecentActivityItem
 */
export interface RecentActivityItem {
    /**
     * 
     * @type {string}
     * @memberof RecentActivityItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentActivityItem
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentActivityItem
     */
    date?: string;
}

/**
 * Check if a given object implements the RecentActivityItem interface.
 */
export function instanceOfRecentActivityItem(value: object): value is RecentActivityItem {
    return true;
}

export function RecentActivityItemFromJSON(json: any): RecentActivityItem {
    return RecentActivityItemFromJSONTyped(json, false);
}

export function RecentActivityItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentActivityItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'date': json['date'] == null ? undefined : json['date'],
    };
}

export function RecentActivityItemToJSON(json: any): RecentActivityItem {
    return RecentActivityItemToJSONTyped(json, false);
}

export function RecentActivityItemToJSONTyped(value?: RecentActivityItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'date': value['date'],
    };
}

